import type { BankAccount } from '../../BankAccounts/Types/bankAccountTypes';

export interface BankDocumentBankAccountLookup {
  id: number;
  accountNumber: string;
  bankName: string;
  currency: string;
  label: string;
}

export const mapBankAccountToBankDocumentLookup = (
  account: BankAccount | undefined | null
): BankDocumentBankAccountLookup | undefined => {
  if (!account) {
    return undefined;
  }

  return {
    id: account.id,
    accountNumber: account.accountNumber,
    bankName: account.bankName,
    currency: account.currency,
    label: `${account.accountNumber} — ${account.bankName} (${account.currency})`,
  };
};
